import React, { useState, useEffect, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';

import chatIcon from '../../../../../../../assets/images/chat.svg';
import wppIcon from '../../../../../../../assets/images/whatsappteste.svg';
import facebookMessengerIcon from '../../../../../../../assets/images/Facebook_Messenger_4_Logo.svg';
import ContainerReport from '../../../../ContainerReport';

import { getCompanyMessagesByChannel } from '../../../../../../../store/actions/reports';
import { sumReportsArray } from '../../../../BotReport/graphic-report-helper';

const CHANNELS_INITIAL_VALUE = {
  webchat: 0,
  whatsapp: 0,
  messenger: 0,
};

/**
 * Component for show the bots quantity of messages by channel report
 *
 * @param {*} props
 */
const OrgBotsTotalMessagesByChannelReport = (props) => {
  const {
    match,
    user,
    getCompanyMessagesByChannel,
    messagesByChannel,
    componentData,
  } = props;
  const {
    parentFilter,
    draggableId,
    onRemoveClick,
    isEditMode,
  } = componentData;

  const { orgId } = match.params;
  const { startDate, endDate } = parentFilter;
  const token = user.dashboard_token;

  const timezone =
    user && user?.selectedCompany
      ? user?.selectedCompany.timezone.fuso
      : undefined;

  const [channels, setChannels] = useState(CHANNELS_INITIAL_VALUE);

  /**
   * Called for fetch new data for this component
   */
  useEffect(() => {
    getCompanyMessagesByChannel(orgId, token, { startDate, endDate }, timezone);
  }, [parentFilter]);

  /**
   * Called for render the component and change values on UI
   */
  useEffect(() => {
    setChannels(getChannelsValue());
  }, [messagesByChannel]);

  /**
   * Get channels value for update the state
   */
  const getChannelsValue = () => {
    const webchat = sumReportsArray(getFilterChannel('webchat'));
    const whatsapp = sumReportsArray(getFilterChannel('whatsapp'));
    const messenger = sumReportsArray(getFilterChannel('messenger'));

    return { webchat, whatsapp, messenger };
  };

  /**
   * Get filter array by his channel
   * @param {string} type
   */
  const getFilterChannel = (type) => {
    return _.filter(messagesByChannel, (message) => message._id === type);
  };

  /**
   * Render report container content for the current report component
   */
  const renderContainerContent = () => {
    return (
      <Fragment>
        <div className="container-dados-relatorio">
          <p className="result-relatorio-yellow">{channels.webchat}</p>
          <br />
          <div className="header-info-relatorio">
            <img src={chatIcon} />
            <span className="tipo-relatorio">Webchat</span>
          </div>
        </div>
        <div className="divider-info-relatorio" />
        <div className="container-dados-relatorio">
          <p className="result-relatorio-yellow">{channels.whatsapp}</p>
          <br />
          <div className="header-info-relatorio">
            <img src={wppIcon} />
            <span className="tipo-relatorio">Whatsapp</span>
          </div>
        </div>
        <div className="divider-info-relatorio" />
        <div className="container-dados-relatorio">
          <p className="result-relatorio-yellow">{channels.messenger}</p>
          <br />
          <div className="header-info-relatorio">
            <img src={facebookMessengerIcon} />
            <span className="tipo-relatorio">Messenger</span>
          </div>
        </div>
      </Fragment>
    );
  };

  return (
    <ContainerReport
      type="absolute"
      icon={chatIcon}
      title="Total por canal"
      containerContent={renderContainerContent()}
      draggableId={draggableId}
      onRemoveClick={onRemoveClick}
      isEditMode={isEditMode}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    bots: state.bots.list,
    user: state.users.signedUser,
    messagesByChannel: state.reports.orgBotsTotalMessageByChannel,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ getCompanyMessagesByChannel }, dispatch);
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(OrgBotsTotalMessagesByChannelReport)
);
